import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ORIGIN, alternatesFor, normalize, pageFromPath } from "../lib/routing";
import { useI18n } from "../contexts/I18nContext";

/**
 * Mantiene canonical + hreflang sincronizados con la ruta durante la navegación SPA.
 * El HTML servido ya viene con estas etiquetas (scripts/seo-prerender.js); esto sólo
 * evita que queden desactualizadas cuando el usuario navega sin recargar.
 */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const { lang } = useI18n();

  useEffect(() => {
    const page = pageFromPath(pathname);

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${ORIGIN}${page ? page[lang] : normalize(pathname)}`;

    document.head.querySelectorAll("link[data-hreflang]").forEach((el) => el.remove());
    alternatesFor(pathname).forEach(({ hreflang, href }) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hreflang;
      link.href = href;
      link.dataset.hreflang = "true";
      document.head.appendChild(link);
    });

    // Rutas privadas (admin, resultado de reserva) no deben indexarse.
    const robots = document.head.querySelector("meta[name='robots']");
    if (robots) robots.content = page ? "index, follow, max-image-preview:large" : "noindex, nofollow";
  }, [pathname, lang]);

  return null;
}
